// extracted by mini-css-extract-plugin
export default {"header":"AlbumBrowser_header__3CxQK","headerMain":"AlbumBrowser_headerMain__Nc5lM","prevLink":"AlbumBrowser_prevLink__fOqCd","nextLink":"AlbumBrowser_nextLink__BKa2f"};